import { DotLoadingIndicator } from '@xing-com/dot-loading-indicator';

import { Styled } from './styles';

const LoadingState: React.FC = () => {
  return (
    <Styled.LoadingStateContainer>
      <DotLoadingIndicator />
    </Styled.LoadingStateContainer>
  );
};

export default LoadingState;
